import apiClient from './config';

const PLATFORM_SETTINGS_BASE = '/api/superadmin/platform/settings';
const PLATFORM_HEALTH_ENDPOINT = '/api/superadmin/platform/health';

export interface ServiceMaintenanceSetting {
    service_key: string;
    service_name: string;
    label: string;
    description: string;
    maintenance_enabled: boolean;
    message?: string | null;
    effective_message: string;
    updated_at?: string | null;
    updated_by_user_id?: number | null;
}

export interface ServiceMaintenanceUpdate {
    service_key: string;
    maintenance_enabled?: boolean;
    message?: string | null;
}

export interface PlatformSettings {
    company_email_only: boolean;
    privileged_mfa_required: boolean;
    privileged_mfa_effective: boolean;
    mfa_environment_enabled: boolean;
    service_maintenance: ServiceMaintenanceSetting[];
}

export interface PlatformHealthService {
    key: string;
    label: string;
    status: string;
    latency_ms?: number | null;
    details: Record<string, unknown>;
    error?: string | null;
}

export interface PlatformHealthResponse {
    status: string;
    checked_at: string;
    services: PlatformHealthService[];
}

export type PlatformSettingsUpdate = Partial<Pick<
    PlatformSettings,
    'company_email_only' | 'privileged_mfa_required'
>> & {
    service_maintenance?: ServiceMaintenanceUpdate[];
};

export async function getPlatformSettings(): Promise<PlatformSettings> {
    const { data } = await apiClient.get<PlatformSettings>(PLATFORM_SETTINGS_BASE);
    return data;
}

export async function updatePlatformSettings(
    payload: PlatformSettingsUpdate,
): Promise<PlatformSettings> {
    const { data } = await apiClient.put<PlatformSettings>(
        PLATFORM_SETTINGS_BASE,
        payload,
    );
    return data;
}

export async function getPlatformHealth(): Promise<PlatformHealthResponse> {
    const { data } = await apiClient.get<PlatformHealthResponse>(PLATFORM_HEALTH_ENDPOINT);
    return data;
}
